import { useNavigate } from 'react-router-dom';

const items = [
  {
    id: 'benefits',
    number: '01',
    title: '抱樹好處',
    subtitle: '了解抱樹帶嚟嘅身心轉化',
    path: '/benefits',
    image: 'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/590093ce-b751-451b-a214-98d86ba177a3_compressed_DSC086061.webp',
    imageAlt: '陽光穿透樹林嘅小徑，兩旁高聳嘅樹幹',
  },
  {
    id: 'steps',
    number: '02',
    title: '如何好好抱樹',
    subtitle: '三步驟溫柔開始你嘅第一次',
    path: '/steps',
    image: 'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/f937ad75-ce25-4de9-ac50-e50706fe5b0b_compressed_DSC085251.webp',
    imageAlt: '佈滿青苔嘅森林地面，倒下嘅樹木同茂密嘅植被',
  },
  {
    id: 'mood-match',
    number: '03',
    title: '選擇一棵樹將情緒交比佢',
    subtitle: '選擇今日心情適合抱嘅樹',
    path: '/mood-match',
    image: 'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/d301730c-e1e1-4614-893f-4f5e77dc265a_compressed_20231118_1119151.webp',
    imageAlt: '仰望樹冠，陽光穿透層層綠葉灑落',
  },
  {
    id: 'daily-wisdom',
    number: '04',
    title: '生活有啲攰？入嚟抱抱自己',
    subtitle: '揀一個生命課題 · 抽取心靈指引',
    path: '/daily-wisdom',
    image: 'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/f2e3eb47-5c6e-4fe7-a142-f94f39be0530_compressed_20231119_1035081.webp',
    imageAlt: '仰望天空，透過佈滿青苔嘅中空樹幹睇見綠葉同光',
  },
];

export default function Directory() {
  const navigate = useNavigate();

  return (
    <section id="directory" className="relative py-10 md:py-16 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {items.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl bg-white border border-black/5 shadow-soft overflow-hidden transition-all duration-300 hover:shadow-soft"
            >
              {/* 16:9 image top with soft warm filter */}
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover object-top saturate-[0.85] brightness-[1.05] sepia-[0.04] transition-transform duration-500 group-hover:scale-[1.02]"
                />
                {/* Subtle warm overlay for cohesion */}
                <div className="absolute inset-0 bg-primary-900/5 mix-blend-multiply"></div>
              </div>

              {/* Text content below image */}
              <div className="px-5 md:px-6 pt-5 pb-5">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-[1.6]">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-500 leading-relaxed">
                      {item.subtitle}
                    </p>
                  </div>
                  <span className="font-heading text-2xl md:text-3xl font-light text-foreground-300/50 shrink-0 leading-none">
                    {item.number}
                  </span>
                </div>

                {/* CTA - bottom-left, organic circle badge style */}
                <div className="mt-4 flex justify-start">
                  <button
                    type="button"
                    onClick={() => navigate(item.path)}
                    className="group/btn inline-flex items-center gap-2.5 text-sm font-semibold text-foreground-900 cursor-pointer whitespace-nowrap transition-colors duration-300 hover:text-foreground-700"
                  >
                    <span className="tracking-wide">進入</span>
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-900 transition-all duration-300 ease-out group-hover/btn:bg-background-300 group-hover/btn:translate-x-1.5">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}